module.exports = __webpack_public_path__ + "img/3rd.c6a636b.png";